/**
 * Plain code/text preview — read-only formatted display.
 * Kept minimal: a `<pre>` block with monospace font and word-wrap. For
 * proper syntax highlighting users should rely on the editor pane.
 */

interface Props {
	content: string;
}

export function CodeTextPreview({ content }: Props) {
	return (
		<pre className="text-[12px] font-mono whitespace-pre-wrap break-all bg-muted/20 rounded p-3 text-foreground">
			{content}
		</pre>
	);
}
